module.exports = __webpack_public_path__ + "img/Super-Sally-SunHero-V1-large.5896195c.png";